import { Component, Directive, ElementRef, Renderer } from '@angular/core';
@Directive({
  selector: '[service-header]'
})
export class ServiceHeaderDirective {
  constructor(element: ElementRef, renderer: Renderer) {
    renderer.setElementStyle(element.nativeElement, 'fontSize', '18px');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/service-header/service-header.directive.ts